<div class="content-div">

  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
  </div>

  <div class="top-bar">
    <span class="page-header" [innerHTML]="pageHeading"></span>
  </div>

  <div class="edit-group-number-placeholder">
    <p *ngIf="isNew">New group number form placeholder</p>
    <p *ngIf="!isNew">Edit group number ID: {{ groupNumberId }}</p>
  </div>

</div>
